import {ReactElement} from "react";
import {Body, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {Button} from "@zendeskgarden/react-buttons";
import {toast} from "react-toastify";
import {useDeleteGprEntityGroupMutation} from "../../../__generated__/generated_types";

interface GPREGroupDeleteModalProps {
    close: (deleted: boolean) => void;
    budgetYear: number;
    groupIds: string[];
}

export function GPREGroupDeleteModal(props: GPREGroupDeleteModalProps): ReactElement {
    const [deleteGroup, {loading: deleteLoading}] = useDeleteGprEntityGroupMutation({
        fetchPolicy: "no-cache"
    });

    function doDelete(ids: string[]): void {
        if(ids.length === 0) {
            return;
        }

        Promise.all(
            ids.map(id => deleteGroup({variables: {budgetYear: props.budgetYear, groupId: id}}))
        ).then(() => {
            toast.success(`Deleted ${ids.length} Group${ids.length > 1 ? "s" : ""}.`);
            props.close(true);
        });
    }

    return <Modal>
        <Header>Delete Group{props.groupIds.length > 1 ? "s" : ""}</Header>
        <Body>
            Are you sure you want to delete {props.groupIds.length} group{props.groupIds.length > 1 ? "s" : ""}?
            <p style={{marginTop: "0.5em", color: "var(--grey-500)", fontSize: "0.85rem"}}>
                The properties under the group(s) will no longer be associated with any group and will use default setup of Initial GPR.
            </p>
        </Body>
        <Footer>
            <FooterItem>
                <Button isBasic onClick={() => props.close(false)}>Cancel</Button>
            </FooterItem>
            <FooterItem>
                <Button isDanger disabled={deleteLoading} onClick={() => doDelete(props.groupIds)}>Delete</Button>
            </FooterItem>
        </Footer>
    </Modal>;
}
